var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoExclamationRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13.667A6.667 6.667 0 107 .333a6.667 6.667 0 000 13.334M6.5 7a.5.5 0 011 0v2.667a.5.5 0 01-1 0zm-.167-2.333a.667.667 0 101.334 0 .667.667 0 00-1.334 0",
    fill: "#D32F2F"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcgMTMuNjY3QTYuNjY3IDYuNjY3IDAgMSAwIDcgLjMzM2E2LjY2NyA2LjY2NyAwIDAgMCAwIDEzLjMzNE02LjUgN2EuNS41IDAgMCAxIDEgMHYyLjY2N2EuNS41IDAgMCAxLTEgMHptLS4xNjctMi4zMzNhLjY2Ny42NjcgMCAxIDAgMS4zMzQgMCAuNjY3LjY2NyAwIDAgMC0xLjMzNCAwIiBmaWxsPSIjRDMyRjJGIi8+PC9zdmc+";
export { SvgInfoExclamationRed as ReactComponent };